import React, { useState } from 'react';
import { User } from 'lucide-react';
import type { RecentUser } from '../../../services';
import { getUserProfileUrl } from '../../../utils/urlUtils';
import { getImageUrl } from '../../../utils';

export interface RecentUserItemProps {
  user: RecentUser;
  period: 1 | 7;
}

export const RecentUserItem = ({ user, period }: RecentUserItemProps) => {
  const [imageError, setImageError] = useState(false);
  const handleClick = () => {
    const profileUrl = getUserProfileUrl(user.username);
    window.open(profileUrl, '_blank', 'noopener,noreferrer');
  };

  const avatarUrl = user.profilePhoto && !imageError ? getImageUrl(user.profilePhoto) : null;

  return (
    <div
      onClick={handleClick}
      className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200 hover:shadow-md hover:border-blue-300 transition-all cursor-pointer"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {avatarUrl ? (
          <div className="flex-shrink-0 w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200">
            <img
              src={avatarUrl}
              alt={user.username}
              className="w-full h-full object-cover"
              onError={() => setImageError(true)}
            />
          </div>
        ) : (
          <div
            className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold ${period === 1
              ? 'bg-gradient-to-br from-blue-500 to-indigo-600'
              : 'bg-gradient-to-br from-purple-500 to-pink-600'
              }`}
          >
            <User className="w-5 h-5" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-gray-800 truncate">{user.username}</p>
          <p className="text-sm text-gray-500 truncate">{user.email}</p>
          <p className="text-xs text-gray-400 mt-1">
            {new Date(user.dateJoined).toLocaleDateString('tr-TR', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </p>
        </div>
      </div>
      {user.isActive ? (
        <span className="flex-shrink-0 px-2 py-1 bg-green-100 text-green-700 rounded-md text-xs font-medium">
          Aktif
        </span>
      ) : (
        <span className="flex-shrink-0 px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium">
          Pasif
        </span>
      )}
    </div>
  );
};
